import { Component } from '@angular/core';
import { BASIC_IMPORTS } from '../../shared/imports/common-imports';
import { LambdaApiService } from '../../shared/services/lambda-api.service';
import {
  TopVendorData,
  FlagType,
} from '../../shared/models/top-vendors-data.model';
import { SpinnerComponent } from '../../shared/components/spinner/spinner.component';

@Component({
  selector: 'app-risk-flag-detail',
  standalone: true,
  imports: [BASIC_IMPORTS, SpinnerComponent],
  templateUrl: './risk-flag-detail.component.html',
  styleUrl: './risk-flag-detail.component.scss',
})
export class RiskFlagDetailComponent {
  isLoading = false;
  cards = [
    {
      title: 'Repetitive Payments',
      subTitle: 'Top HCPs with unusual payment patterns',
      flagValues: [] as any[],
      flagType: FlagType.OPERATIONAL,
      data: [] as TopVendorData[],
      totalVendors: 0,
    },
    {
      title: 'Market Share & Caps',
      subTitle:
        'Top HCPs with significant market share or recurring top positions',
      flagValues: [] as any[],
      flagType: FlagType.FINANCIAL,
      data: [] as TopVendorData[],
      totalVendors: 0,
    },
  ];
  constructor(private readonly apiService: LambdaApiService) {}
  ngOnInit() {
    this.isLoading = true;

    const promises = this.cards.map((card) => {
      const topVendorsPromise = this.apiService
        .getTopVendors(card.flagType)
        .then((data) => {
          card.data = data.vendors;
        });

      const percentagesPromise = this.apiService
        .getPercentages(card.flagType)
        .then((data) => {
          card.flagValues = [
            { val: data.high, color: 'red' },
            { val: data.medium, color: 'yellow' },
            { val: data.low, color: 'green' },
          ];
          card.totalVendors = data.total;
        });

      return Promise.all([topVendorsPromise, percentagesPromise]);
    });

    Promise.all(promises).then(() => {
      this.isLoading = false;
    });
  }
}
